var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.values),function(row,index){return [_c('div',{key:("acfNoteBlock_" + index)},[_c('v-card-text',[_c('h3',[_c('b',[_vm._v(_vm._s(row.label))])]),_vm._v(" "+_vm._s(row.value)+" ")])],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }